<template>
    <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
        <b-form @submit.prevent="handleSubmit(salvar)">
            <h6 class="mb-3 text-left">
                Edite e salve os dados gerais da Dispensa/Inexigibilidade
                <b-button class="float-right m-1" size="sm" type="submit">
                    <font-awesome-icon icon="save" />
                    Salvar
                </b-button>
            </h6>
            <b-row class="w-100">
                <b-col cols="6">
                    <b-row class="d-flex align-items-start">
                        <b-col cols="6">
                            <default-form-validation-provider label="Número" v-slot="defaultState">
                                <b-form-input id="input-numero" v-model="licitacao.NrLicitacao" :state="defaultState.state"
                                    type="number">
                                </b-form-input>
                            </default-form-validation-provider>
                        </b-col>
                        <b-col cols="2" class="d-flex justify-content-center align-items-center mt-4 pt-2">
                            <span class="h2">/</span>
                        </b-col>
                        <b-col cols="4">
                            <default-form-validation-provider label="Ano" v-slot="defaultState">
                                <b-form-input id="input-ano" v-model="licitacao.NrAnoLicitacao" :state="defaultState.state"
                                    type="number"></b-form-input>
                            </default-form-validation-provider>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="6">
                    <default-form-validation-provider label="Modalidade" v-slot="defaultState">
                        <b-form-select id="select-modalidade" v-model="licitacao.IdModalidade" :options="listaModalidades"
                            @change="carregarReferenciasBaseLegal" :state="defaultState.state">
                        </b-form-select>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="6">
                    <default-form-validation-provider label="Natureza do Objeto" v-slot="defaultState">
                        <b-form-select id="select-natureza-objeto" v-model="licitacao.IdNaturezaObjeto"
                            @change="limparNaturezaObra" :options="listaNaturezasObjeto" :state="defaultState.state">
                        </b-form-select>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="6">
                    <b-overlay :show="loadingReferencias">
                        <default-form-validation-provider label="Base Legal" v-slot="defaultState">
                            <b-form-select id="select-base-legal" v-model="licitacao.IdReferenciaLegal"
                                :options="listaBasesLegais" :state="defaultState.state" :disabled=!licitacao.IdModalidade>
                            </b-form-select>
                        </default-form-validation-provider>
                    </b-overlay>
                </b-col>
                <b-col cols="6">
                    <default-form-validation-provider :rules="disabledNaturezaObra ? '' : 'required'"
                        label="Natureza da Obra" v-slot="defaultState">
                        <b-form-select id="select-natureza-obra" v-model="licitacao.IdNaturezaObra"
                            :disabled="disabledNaturezaObra" :options="listaNaturezasObra" :state="defaultState.state">
                        </b-form-select>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="6">
                    <default-form-validation-provider label="Nr do Processo Administrativo" v-slot="defaultState" rules="max:30">
                        <b-form-input id="input-nr-processo-administrativo" v-model="licitacao.DeNrProcessoAdmin"
                            :state="defaultState.state" type="text"></b-form-input>
                    </default-form-validation-provider>
                </b-col>
                <!--<b-col cols="6">
                    <default-form-validation-provider label="Há previsão de pagamento antecipado?"
                        tooltip="Quando houver previsão de antecipação de pagamento nos moldes da MP 961/2020, marcar SIM neste campo e juntar a justificativa sobre a antecipação de pagamento ao aquivo do Edital da Licitação ou da Justificativa da Dispensa/Inexigibilidade.">
                        <b-form-radio-group v-model="licitacao.FlPagamentoAntecipado" :options="pagamentoAntecipadoOptions"
                            size="sm">
                        </b-form-radio-group>
                    </default-form-validation-provider>
                </b-col>-->
                <b-col cols="6">
                    <default-form-validation-provider label="Data de Ratificação" v-slot="defaultState">
                        <b-form-datepicker id="input-data-ratificacao" :state="defaultState.state"
                            v-model="licitacao.DtHomologacao" v-bind="datePickerProps">
                        </b-form-datepicker>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="6">
                    <default-form-validation-provider label="Objeto" v-slot="defaultState" rules="max:1000">
                        <b-form-textarea id="input-objeto-licitacao" :state="defaultState.state"
                            v-model="licitacao.DeObjetoLicitacao" rows="3" max-rows="6"></b-form-textarea>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="6">
                    <default-form-validation-provider v-if="licitacao.getTipoArquivo() === 'salvo'"
                        label="Justificativa da Dispensa/Inexigibilidade" rules="">
                        <span v-if="licitacao && licitacao.ArquivoEdital">Nome: {{
                            licitacao.ArquivoEdital.NmArquivo }}</span>
                        <div class="d-flex justify-content-center">
                            <btn-download class="mr-2" :fazerDownload="baixarAnexo"
                                :parametros="licitacao.ArquivoEdital" />
                            <b-link class="text-dark" @click="removerArquivoEdital()">
                                <font-awesome-icon icon="times" />
                                <div style="font-size: 12px">Remover</div>
                            </b-link>
                        </div>
                    </default-form-validation-provider>
                    <default-form-validation-provider v-else label="Justificativa da Dispensa/Inexigibilidade (PDF)"
                        v-slot="defaultState">
                        <b-form-file v-model="licitacao.ArquivoEdital" placeholder="Nenhum arquivo selecionado"
                            accept="application/pdf" :state="defaultState.state"></b-form-file>
                    </default-form-validation-provider>
                </b-col>
            </b-row>
        </b-form>
    </validation-observer>
</template>

<script lang="ts">
import { Component, Ref, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { store } from "@/store"
import { UtilsTS } from '@/utilsts'
import { ValidationObserver } from "vee-validate"
import { eventBus } from '@/main';
import BtnDownload from '@/components/shared/btn-download.vue'
import { DatePickerDefaultProps, FormGroupDefaultCols } from '@/types/form-default-props'
import DefaultFormValidationProvider from '@/components/shared/DefaultFormValidationProvider.vue'
import ldiService from '@/services/licitacoes/ldiService'
import { Licitacao } from '@/types/licitacoes/ldi/licitacao'
import { PortalError } from '@/types/portal-error'
import { SelectValue } from '@/types/select-value'
import { ArquivoLicitacao } from '@/types/licitacoes/arquivo-licitacao'

const CompProps = Vue.extend({
    name: 'AbaEditarDadosIniciais',
    components: { BtnDownload, DefaultFormValidationProvider, ValidationObserver },
    props: {
        lic: {
            type: Object,
            required: true
        }
    }
})

@Component
export default class AbaEditarDadosIniciais extends mixins(UtilsTS, CompProps) {
    @Ref('validationobserver') validationobserver: InstanceType<typeof ValidationObserver>
    datePickerProps = DatePickerDefaultProps
    formGroupCols = FormGroupDefaultCols
    valorPadraoSelect: SelectValue = { value: '', text: 'SELECIONE UMA OPÇÃO', disabled: true }
    listaModalidades: SelectValue[] = [this.valorPadraoSelect]
    listaNaturezasObjeto: SelectValue[] = [this.valorPadraoSelect]
    listaNaturezasObra: SelectValue[] = [this.valorPadraoSelect]
    listaBasesLegais: SelectValue[] = [this.valorPadraoSelect]
    loadingReferencias = false
    licitacao: Licitacao = new Licitacao()
    /*pagamentoAntecipadoOptions = [
        { text: 'Sim', value: 'S' },
        { text: 'Não', value: 'N' },
    ]*/

    get disabledNaturezaObra() {
        //console.log('disabledNaturezaObra', this.licitacao.IdNaturezaObjeto)
        if (this.licitacao.IdNaturezaObjeto != 2) {
            this.licitacao.IdNaturezaObra = undefined
            return true
        }
        return false
    }

    async carregarReferenciasBaseLegal(): Promise<void> {
        try {
            this.loadingReferencias = true
            // await new Promise(r => setTimeout(r, 2000));
            const response = await ldiService.listarRefBasesLegais(this.licitacao.IdModalidade)
            if (response && Array.isArray(response.data)) {
                this.listaBasesLegais = [this.valorPadraoSelect, ...response.data.map(re => {
                    return {
                        value: re.IdReferenciaLegal, text: re.DeReferenciaLegal
                    }
                })]
            } else {
                throw new PortalError('Não foram encontradas referências de base legal')
            }
        } catch (e: any) {
            console.error('Falha ao carregar referencias base legal', e)
            this.$toast.error(e.message)
        } finally {
            this.loadingReferencias = false
        }
    }
    limparNaturezaObra(): void {
        this.licitacao.IdNaturezaObra = undefined
    }
    /** Validar e salvar dados iniciais de nova licitação */
    async salvar(): Promise<void> {
        store.blockScreen = true
        try {
            const isValid = await this.validationobserver.validate();
            if (!isValid) {
                console.error(this.validationobserver)
            } else {
                //salvar a licitação 
                const retorno = await ldiService.salvarDadosIniciais(this.licitacao)
                this.$emit('atualizarLicitacao', retorno)
                this.$toast.success(`Os dados iniciais da dispensa/inexigibilidade foram salvos!`)
                //vamos atualizar a instância local de licitação, para que o File se comporte corretamente.
                // se isto não funcionar, o ideal é o componente pai forçar um rerender deste aqui.
                this.licitacao = retorno
                eventBus.$emit('atualizar-status-licitacao', retorno.FlSituacao)
            }
        } catch (e: any) {
            this.tratarError(e, true)
        } finally {
            store.blockScreen = false
        }
    }

    async montarCombos(): Promise<void> {
        const response = await ldiService.getCombosDI()
        this.listaModalidades.push(...response.modalidades
            .map(m => {
                return { value: m.IdModalidade, text: m.DeModalidade }
            }))
        this.listaNaturezasObjeto.push(...response.naturezasObjeto.map(no => {
            return { value: no.IdNaturezaObjeto, text: no.DeNaturezaObjeto }
        }))
        this.listaNaturezasObra.push(...response.naturezasObra.map(no => {
            return { value: no.IdNaturezaObra, text: no.DeNaturezaObra }
        }))
        if (this.licitacao.IdReferenciaLegal > 0) {
            await this.carregarReferenciasBaseLegal()
        }
    }
    async baixarAnexo(arquivo: ArquivoLicitacao) {
        const response = await ldiService.baixarAnexo(String(arquivo.IdArquivo))
        this.download(`edital-${this.licitacao.NumeroAnoLicitacao}`, response.data)
    }
    removerArquivoEdital() {
        this.licitacao.ArquivoEdital = undefined
    }
    async mounted() {
        try {
            if (this.lic.IdLicitacao > 0) {
                this.licitacao = this.lic
            }
            store.blockScreen = true
            await this.montarCombos()
        } catch (e: any) {
            console.error('Problema ao montar o componente EditarDadosIniciaisLicitacao', e)
        } finally {
            store.blockScreen = false
        }
    }
}


</script>

<style></style>